import {
    createColumnHelper,
} from '@tanstack/react-table';
import { IoTriangleOutline } from "react-icons/io5";
import { format } from "date-fns";
import { colors, status } from 'utils';

const columnHelper = createColumnHelper();
const columns = (onViewDetails, t) => {

    return [
        columnHelper.accessor("status", {
            header: () => <span>{t("table.status")}</span>,
            cell: (info) => {
                const value = info.getValue();
                if (!value) return null;
                return (
                    <button className={`${status(t)[value] ? colors[value] : ""} cursor-auto text-black text-xs font-bold rounded-full px-4 py-1 shadow-inner border`}>
                        {status(t)[value] ? status(t)[value] : value}
                    </button>
                )
            },
        }),
        columnHelper.accessor("id", {
            header: () => <span>{t("table.id")}</span>,
        }),
        columnHelper.accessor("operator", {
            header: () => <span>{t("table.operator")}</span>,
            cell: info => {
                const { operator } = info.row.original;
                if (!operator) return null;
                const { name, lastName, secondLastName } = operator.user;

                return (
                    <span>
                        {name} {lastName} {secondLastName}
                    </span>
                )
            },
        }),
        columnHelper.accessor("tipoUnidad", {
            header: () => <span>{t("table.typeUnit")}</span>,
            cell: info => {
                const { truck } = info.row.original;
                if (!truck) return null;
                
                return (
                    <span>
                       {truck.name ?? ""}
                    </span>
                )
            },
        }),
        columnHelper.accessor("unidad", {
            header: () => <span>{t("table.unit")}</span>,
            cell: info => {
                const { truck } = info.row.original;
                if (!truck) return null;
                
                return (
                    <span>
                       {truck.plateNumber ?? ""}
                    </span>
                )
            },
        }),
        columnHelper.accessor("origen", {
            header: () => <span>{t("table.origin")}</span>,
            cell: info => {
                const { destination } = info.row.original;
                if (!destination || destination?.length === 0) return null;
                
                const findOrigin = destination.find((item) => item.type === "origen");
                if (!findOrigin) return null;
                return (
                    <span>
                       {findOrigin.shPt ?? ""}
                    </span>
                )
            },
        }),
        columnHelper.accessor("destination", {
            header: () => <span>{t("table.destinations")}</span>,
            cell: info => {
                if (!info.getValue()) return null;
                const { destination } = info.row.original;
                const destinationLength = destination?.length ? destination.filter(item => item.type === "destino").length : 0;
                return (
                    <span>
                        {destinationLength} {t("table.destinations")}
                    </span>
                )
            },
        }),
        columnHelper.accessor("createdAt", {
            header: () => <span>{t("table.dateStart")}</span>,
            cell: info => {
                if (!info.getValue()) return null;
                return (
                    <span>
                        {format(new Date(info.getValue()), "dd/MM/yyyy HH:mm:ss")}
                    </span>
                )
            },
        }),
        columnHelper.accessor("startTrip", {
            header: () => <span>{t("table.actualStartDate")}</span>,
            cell: info => {
                if (!info.getValue()) return null;
                return (
                    <span>
                        {format(new Date(info.getValue()), "dd/MM/yyyy HH:mm:ss")}
                    </span>
                )
            },
        }),
        columnHelper.accessor("endTrip", {
            header: () => <span>{t("table.actualEndDate")}</span>,
            cell: info => {
                if (!info.getValue()) return null;
                return (
                    <span>
                        {format(new Date(info.getValue()), "dd/MM/yyyy HH:mm:ss")}
                    </span>
                )
            },
        }),
        columnHelper.display({
            id: "actions",
            cell: (info) => (
                <div onClick={()=>onViewDetails(info.row.original)} className="flex justify-center">
                    <IoTriangleOutline className="rotate-180 text-xl cursor-pointer hover:text-yellow-800" />
                </div>
            ),
        }),
    ]
}

export default columns;